module.exports = __webpack_public_path__ + "img/id.29d7dbd5.svg";